import React from 'react';

const CircularProgress = ({ className }) => (
    <div className="flex items-center justify-center flex-1 w-full text-4xl font-heading text-brand-olive-900"></div>
);

export default CircularProgress;
